import { FormalizeCompany, FormalizeRequisition } from '../../../models/formalizePayload';
import { Requisition } from '../../../models/requisition';
import { UiError } from '../../../models/uiError';
var EditSharedReqPageController = /** @class */ (function () {
    /*@ngInject*/
    function EditSharedReqPageController($scope, $state, $transitions, $rootScope, $timeout, requisitionService, jobService, companyService, alertsAndNotificationsService, MESSAGECONSTANTS, uibModalService, utilityService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$transitions = $transitions;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.requisitionService = requisitionService;
        this.jobService = jobService;
        this.companyService = companyService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.uibModalService = uibModalService;
        this.utilityService = utilityService;
    }
    EditSharedReqPageController.prototype.$onInit = function () {
        var _this = this;
        this.$stateParams = this.$transition$.params();
        this.isTransitionAbortRequired = true;
        this.isLocationChange = false;
        this.isLocationChangeInitial = false;
        this.recruiterList = [];
        this.selectedRecruiters = [];
        this.req = {};
        this.job = {};
        this.uploadReqWizard = {};
        this.clientOrBuLabel = 'Client';
        this.requisitionNote = "";
        this.requisitionInfo = this.$stateParams.requisitionInfo;
        // flags
        this.disableUploadButtonFlag = true;
        this.savingFlag = false;
        this.step2DetailsSavedFlag = false;
        this.workflowStepsSavedFlag = false;
        this.disablePrevButtonFlag = false;
        this.disableSaveButtonFlag = true;
        this.disableNextButtonFlag = true;
        this.disableCancelButtonFlag = false;
        this.disableAllButtonsFlag = false;
        this.loadingAdjustedCandidatesCountFlag = false;
        this.step1RequestWasInProgressFlag = false;
        this.step2RequestWasInProgressFlag = false;
        this.editTitleFlag = false;
        this.editJobLocationFlag = false;
        this.step1DetailsTempObject = {};
        this.workflowStepsTempObject = {};
        this.showWizardSteps = false;
        //error objects
        this.step1Error = null;
        this.step2Error = null;
        this.jobId = this.$stateParams.jobId;
        this.corporateId = this.$stateParams.corporateCompanyId;
        this.jobName = this.$stateParams.jobName;
        this.jobType = this.$stateParams.jobType;
        this.buId = this.$stateParams.buId;
        this.isCorporate = this.companyService.isCorporateCompany();
        this.updateActionButtons();
        this.req = new Requisition();
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.userId = this.$rootScope.userDetails.id;
        this.getAssignableRecruitersList(function () {
            _this.getAssignedRecruiters(function () {
                _this._setAssignedRecruiters();
                _this._getSharedRequisitionNote(function () {
                    _this._createStepTempObject(2);
                });
            });
        });
        // error objects
        this.step1Error = new UiError();
        this.step2Error = new UiError();
        // edit mode
        this.currentJobStatus = 'OPEN';
        $('#uploadReqWizard').wizard();
        // }
        this.showWizardSteps = true;
        // get license preferences as job id is available
        this.getCorporateCompanyLicensePreference(function () {
            _this.disableNextButtonFlag = false;
        });
        //set the flags for edit mode
        this.disableUploadButtonFlag = true;
        this.step2DetailsSavedFlag = true;
        this._initStepsWizard();
        this._handleBrowserEvents();
        this.setFormalizeActivityPayload();
    };
    EditSharedReqPageController.prototype._initStepsWizard = function () {
        var _this = this;
        // Handle Wizard operations
        $('#uploadReqWizard').on('actionclicked.fu.wizard', function (evt, data) {
            if (data.direction == "next") {
                var currentStep = data.step;
                switch (currentStep) {
                    case 1:
                        // Do Nothing
                        break;
                    case 2:
                        if (_this.step1RequestWasInProgressFlag) {
                            // save or request was in progress and it is now completed. The success has has triggered a next event.
                            // set the flag, do nothing and move to next step.
                            _this._enableStepActionsOnWizard(data.step);
                        }
                        else {
                            // there was no step2 request or save in progress. the event was triggered by user click of next button
                            if (_this._isStepDataValid(data.step)) {
                                if (_this._hasStepDataChanged(data.step)) {
                                    if (_this._hasRecruitersBeingUnAssigned()) {
                                        evt.preventDefault();
                                        _this._showRecruitersUnAssignedWarning(function () {
                                            _this.step1RequestWasInProgressFlag = true;
                                            _this.saveStep1Details(function () {
                                                // move to next step as the save is done.
                                                $("#uploadReqWizard").wizard('next');
                                                _this._enableStepActionsOnWizard(3);
                                                _this.disableSaveButtonFlag = true;
                                            }, function (error) {
                                                _this._enableStepActionsOnWizard(3);
                                                // show error messages
                                                if (_this.$rootScope.isOnline) {
                                                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                                }
                                                // no move to next step.
                                            });
                                        }, function () {
                                            // this.recruiterList = angular.copy(this.step1DetailsTempObject.recruiters);
                                            _this._setAssignedRecruiters();
                                        });
                                    }
                                    else {
                                        _this.step1RequestWasInProgressFlag = true;
                                        _this.saveStep1Details(function () {
                                            $("#uploadReqWizard").wizard('next');
                                            _this.disableSaveButtonFlag = true;
                                            _this._enableStepActionsOnWizard(3);
                                        }, function (error) {
                                            _this._enableStepActionsOnWizard(3);
                                            // show error messages
                                            if (_this.$rootScope.isOnline) {
                                                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                            }
                                            // no move to next step.
                                        });
                                    }
                                }
                                else {
                                    _this._createStepTempObject(data.step + 1);
                                }
                            }
                            else {
                                // prevent the move. Validation errors will show up.
                                evt.preventDefault();
                            }
                            // if a request was triggered, prevent the default behaviour of moving to next, till the requests are completed.
                            if (_this.step1RequestWasInProgressFlag) {
                                // prevent default move.
                                evt.preventDefault();
                                _this.disableAllButtonsFlag = true;
                            }
                        }
                        break;
                    case 3:
                        break;
                    default:
                        break;
                }
            }
            else if (data.direction == "previous") {
                switch (data.step) {
                    case 1:
                        // Do Nothing
                        break;
                    case 2:
                        _this._createStepTempObject(data.step - 1);
                        // not possible
                        break;
                    case 3:
                        // do nothing
                        break;
                    default:
                        break;
                }
            }
        });
        $('#uploadReqWizard').on('finished.fu.wizard', function (evt, data) {
            _this.$state.go('missioncontrol.requisitions');
        });
        $('#uploadReqWizard').on('changed.fu.wizard', function (evt, data) {
            switch (data.step) {
                case 1:
                case 2:
                case 3:
                    _this.updateActionButtons();
                    break;
            }
        });
    };
    EditSharedReqPageController.prototype._hasRecruitersBeingUnAssigned = function () {
        return this.step1DetailsTempObject.recruiterIds.length > this.selectedRecruiters.length;
    };
    EditSharedReqPageController.prototype._showRecruitersUnAssignedWarning = function (saveCallback, cancelCallback) {
        var _this = this;
        var selectedRecruiterIds = this.selectedRecruiters.map(function (val, index) {
            return val.userId;
        });
        var removedRecruiterIds = _.difference(this.step1DetailsTempObject.recruiterIds, selectedRecruiterIds);
        console.log(removedRecruiterIds);
        var recruiterNames = [];
        angular.forEach(removedRecruiterIds, function (recruiterId, recruiterIdIndex) {
            angular.forEach(_this.recruiterList, function (recruiter, recruiterIndex) {
                if (recruiterId == recruiter.userId) {
                    recruiterNames.push(recruiter.name);
                }
            });
        });
        var warningMessage = this._getWarningMessage(recruiterNames);
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: warningMessage,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    saveCallback();
                }
                else {
                    cancelCallback();
                }
            }
        });
    };
    EditSharedReqPageController.prototype._getWarningMessage = function (recruiterNames) {
        var message = "<b>";
        var totalCount = recruiterNames.length;
        angular.forEach(recruiterNames, function (name, index) {
            if (index == totalCount - 1) {
                message = message + name;
            }
            else if (index == totalCount - 2) {
                message = message + name + " & ";
            }
            else {
                message = message + name + ", ";
            }
        });
        return message + "</b> shall be removed as assigned recruiter(s) from all the candidates in the requisition. Do you still want to continue?";
    };
    EditSharedReqPageController.prototype._createStepTempObject = function (currentStep) {
        switch (currentStep) {
            case 1:
                // Do Nothing
                break;
            case 2:
                var recruiterIds_1 = [];
                angular.forEach(this.selectedRecruiters, function (val, key) {
                    recruiterIds_1.push(val.userId);
                });
                this.step1DetailsTempObject = {
                    jobId: this.jobId,
                    vendorId: this.companyId,
                    recruiterIds: recruiterIds_1,
                    requisitionNote: this.requisitionNote
                };
                break;
            case 3:
                break;
            default:
                break;
        }
    };
    EditSharedReqPageController.prototype._isStepDataValid = function (currentStep) {
        var stepDataValidityFlag = true;
        switch (currentStep) {
            case 1:
                // Do Nothing
                break;
            case 2:
                // set the form to submitted
                this.forms.step1Form.$submitted = true;
                //check all the values one by one.
                if (this.forms.step1Form.$invalid || (this.selectedRecruiters.length == 0)) {
                    this.step1Error.hasErrorFlag = true;
                    this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                    stepDataValidityFlag = false;
                }
                else {
                    this.step1Error.hasErrorFlag = false;
                    this.step1Error.errorMessage = '';
                }
                break;
            case 3:
                break;
            default:
                break;
        }
        return stepDataValidityFlag;
    };
    EditSharedReqPageController.prototype._hasStepDataChanged = function (currentStep) {
        var stepDataHasChangedFlag = false;
        switch (currentStep) {
            case 1:
                break;
            case 2:
                var recruiterIds_2 = [];
                angular.forEach(this.selectedRecruiters, function (val, key) {
                    recruiterIds_2.push(val.userId);
                });
                var currentStep1DataObject = {
                    jobId: this.jobId,
                    vendorId: this.companyId,
                    recruiterIds: recruiterIds_2,
                    requisitionNote: this.requisitionNote
                };
                stepDataHasChangedFlag = !(_.isEqual(this.step1DetailsTempObject, currentStep1DataObject));
                break;
            case 3:
                break;
            default:
                break;
        }
        return stepDataHasChangedFlag;
    };
    EditSharedReqPageController.prototype._enableStepActionsOnWizard = function (currentStep) {
        switch (currentStep) {
            case 1:
                //do nothing
                break;
            case 2:
                //do nothing
                break;
            case 3:
                this.step1RequestWasInProgressFlag = false;
                break;
            default:
                break;
        }
        this.disableAllButtonsFlag = false;
    };
    EditSharedReqPageController.prototype.wizardSaveStepData = function () {
        var _this = this;
        var currentStep = $('#uploadReqWizard').wizard('selectedItem').step;
        if (this._isStepDataValid(currentStep)) {
            if (this._hasStepDataChanged(currentStep)) {
                switch (currentStep) {
                    case 1:
                        // Do Nothing
                        break;
                    case 2:
                        if (this._hasRecruitersBeingUnAssigned()) {
                            this._showRecruitersUnAssignedWarning(function () {
                                _this.disableAllButtonsFlag = true;
                                _this.savingFlag = true;
                                _this.saveStep1Details(function () {
                                    _this.disableAllButtonsFlag = false;
                                    _this.savingFlag = false;
                                    _this._enableStepActionsOnWizard(3);
                                    if (_this.$rootScope.isOnline) {
                                        var successMessage = 'The Requisition details have been saved in Draft Status.';
                                        if (_this.currentJobStatus == 'OPEN') {
                                            successMessage = 'The Requisition details have been saved.';
                                        }
                                        _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                                    }
                                    _this._createStepTempObject(currentStep);
                                }, function (error) {
                                    _this.disableAllButtonsFlag = false;
                                    _this.savingFlag = false;
                                    if (_this.$rootScope.isOnline) {
                                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                    }
                                });
                            }, function () {
                                // this.job.recruiters = angular.copy(this.step1DetailsTempObject.recruiters);
                                _this._setAssignedRecruiters();
                            });
                        }
                        else {
                            this.disableAllButtonsFlag = true;
                            this.savingFlag = true;
                            this.saveStep1Details(function () {
                                _this._enableStepActionsOnWizard(3);
                                _this.disableAllButtonsFlag = false;
                                _this.savingFlag = false;
                                if (_this.$rootScope.isOnline) {
                                    var successMessage = 'The Requisition details have been saved in Draft Status.';
                                    if (_this.currentJobStatus == 'OPEN') {
                                        successMessage = 'The Requisition details have been saved.';
                                    }
                                    _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                                }
                                _this._createStepTempObject(currentStep);
                            }, function (error) {
                                _this.disableAllButtonsFlag = false;
                                _this.savingFlag = false;
                                if (_this.$rootScope.isOnline) {
                                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                }
                            });
                        }
                        break;
                    case 3:
                        break;
                    default:
                        break;
                }
            }
            else {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage('Nothing to be saved!', 'info');
                }
            }
        }
    };
    EditSharedReqPageController.prototype.validateStepOne = function () {
        if (this.forms.step1Form.$submitted) {
            if (this.forms.step1Form.$invalid || (this.job.recruiters.length == 0)) {
                this.step1Error.hasErrorFlag = true;
                this.step1Error.errorMessage = 'Please enter all mandatory fields.';
            }
            else {
                this.step1Error.hasErrorFlag = false;
                this.step1Error.errorMessage = '';
            }
        }
    };
    EditSharedReqPageController.prototype.wizardCancel = function () {
        this.$state.go('missioncontrol.requisitions');
    };
    EditSharedReqPageController.prototype.resetStepData = function (step, successCallback) {
        var _this = this;
        this.$timeout(function () {
            switch (step) {
                case 1:
                    //do nothing
                    break;
                case 2:
                    //do nothing
                    _this._setAssignedRecruiters();
                    break;
                case 3:
                    break;
                default:
                    break;
            }
            if (successCallback) {
                successCallback();
            }
        }, 100);
    };
    EditSharedReqPageController.prototype.getAssignableRecruitersList = function (successCallback) {
        var _this = this;
        this.loadingRecruitersFlag = true;
        this.requisitionService.getVendorRecruiters(this.companyId, this.jobId, function (data) {
            _this.loadingRecruitersFlag = false;
            angular.forEach(data, function (val, key) {
                val.name = val.firstName;
                if (!_.isNull(val.lastName)) {
                    val.name += ' ' + val.lastName;
                }
            });
            _this.recruiterList = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingRecruitersFlag = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    EditSharedReqPageController.prototype.getAssignedRecruiters = function (successCallback) {
        var _this = this;
        this.requisitionService.getAssignedVendorRecruiters(this.jobId, this.companyId, function (data) {
            _this.assignedRecruiterIds = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    EditSharedReqPageController.prototype._getSharedRequisitionNote = function (successCallback) {
        var _this = this;
        this.jobService.getSharedRequisitionNote(this.jobId, this.companyId, function (data) {
            _this.requisitionNote = data.requisitionNote;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    EditSharedReqPageController.prototype._setAssignedRecruiters = function () {
        var _this = this;
        this.selectedRecruiters = [];
        angular.forEach(this.assignedRecruiterIds, function (val, key) {
            var recruiterIndex = _.findIndex(_this.recruiterList, { 'userId': val });
            if (recruiterIndex !== -1) {
                _this.recruiterList[recruiterIndex].selected = true;
                _this.selectedRecruiters.push(_this.recruiterList[recruiterIndex]);
            }
        });
    };
    EditSharedReqPageController.prototype.getCorporateCompanyLicensePreference = function (successCallback, errorCallback) {
        var _this = this;
        this.jobService.getSharedJobWorkflowDetails(this.jobId, function (data) {
            _this.companyLicensePreference = data;
            successCallback();
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (errorCallback) {
                errorCallback();
            }
        });
    };
    EditSharedReqPageController.prototype.saveStep1Details = function (successCallback, errorCallback) {
        var _this = this;
        this.utilityService.showLoadingModal("Saving...");
        if (this._hasRecruitersChanged()) {
            this.savingFlag = true;
            var recruiterIds_3 = [];
            angular.forEach(this.selectedRecruiters, function (val, key) {
                recruiterIds_3.push(val.userId);
            });
            var step1SaveObject = {
                jobId: this.jobId,
                vendorId: this.companyId,
                recruiterIds: recruiterIds_3
            };
            this.requisitionService.assignRecruiters(step1SaveObject, function (data) {
                if (_this._hasNoteChanged()) {
                    _this._saveRequisitionNote(successCallback, errorCallback);
                    _this._createStepTempObject(2);
                }
                else {
                    _this.savingFlag = false;
                    _this.step2DetailsSavedFlag = true;
                    if (!_.isUndefined(successCallback)) {
                        successCallback();
                    }
                    _this.utilityService.hideLoadingModal();
                }
            }, function (error) {
                _this.savingFlag = false;
                if (!_.isUndefined(errorCallback)) {
                    errorCallback(error);
                }
                _this.utilityService.hideLoadingModal();
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this._saveRequisitionNote(successCallback, errorCallback);
        }
    };
    EditSharedReqPageController.prototype._hasRecruitersChanged = function () {
        var recruiterIds = [];
        angular.forEach(this.selectedRecruiters, function (val, key) {
            recruiterIds.push(val.userId);
        });
        return !_.isEqual(this.step1DetailsTempObject.recruiterIds, recruiterIds);
    };
    EditSharedReqPageController.prototype._hasNoteChanged = function () {
        return this.step1DetailsTempObject.requisitionNote !== this.requisitionNote;
    };
    EditSharedReqPageController.prototype._saveRequisitionNote = function (successCallback, errorCallback) {
        var _this = this;
        this.savingFlag = true;
        var payload = {
            jobId: this.jobId,
            companyId: this.companyId,
            note: this.requisitionNote
        };
        this.jobService.addSharedRequisitionNote(payload, function (data) {
            _this.savingFlag = false;
            _this.step2DetailsSavedFlag = true;
            _this._createStepTempObject(2);
            if (successCallback) {
                successCallback();
            }
            _this.utilityService.hideLoadingModal();
        }, function (error) {
            _this.savingFlag = false;
            if (errorCallback) {
                errorCallback(error);
            }
            _this.utilityService.hideLoadingModal();
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    EditSharedReqPageController.prototype.updateActionButtons = function () {
        var _this = this;
        var wizardCurrentStep = $('#uploadReqWizard').wizard('selectedItem').step;
        switch (wizardCurrentStep) {
            case 1:
                this.disableSaveButtonFlag = false;
                this.disablePrevButtonFlag = true;
                break;
            case 2:
                this.disableSaveButtonFlag = false;
                break;
            case 3:
                this.disableSaveButtonFlag = false;
                break;
            default:
                break;
        }
        this.$timeout(function () {
            _this.$scope.$apply();
        }, 200);
    };
    //Handle navigating away when data is unsaved
    EditSharedReqPageController.prototype.uiCanExit = function (transitions) {
        var _this = this;
        var toState = transitions.to().name;
        var toParams = transitions.params();
        var currentStep = $("#uploadReqWizard").wizard('selectedItem');
        if (this._hasStepDataChanged(currentStep.step) && this.isTransitionAbortRequired && toState !== "login") {
            transitions.abort();
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        _this.isTransitionAbortRequired = false;
                        _this.resetStepData(currentStep.step);
                        // Handling data change when clicked on Switch company 
                        if (_this.$rootScope.switchClicked) {
                            _this.$rootScope.switchClicked = false;
                            // this.companyService.showAllCompanies();
                            _this.uibModalService.showAllCompanies();
                        }
                        else {
                            _this.$state.go(toState, toParams, { reload: true });
                        }
                    }
                    else {
                        if (_this.$rootScope.switchClicked) {
                            _this.$rootScope.switchClicked = false;
                        }
                    }
                }
            });
        }
        else {
            // If clicked on switch company without changing data
            if (this.$rootScope.switchClicked && !this._hasStepDataChanged(currentStep.step)) {
                transitions.abort();
                this.$timeout(function () {
                    // this.companyService.showAllCompanies();
                    _this.uibModalService.showAllCompanies();
                }, 150);
                this.$rootScope.switchClicked = false;
            }
        }
    };
    EditSharedReqPageController.prototype._handleBrowserEvents = function () {
        var _this = this;
        //Handle Browser back/forward change
        var unbindLocationChangeEvent = this.$scope.$on('$locationChangeStart', function (event, toState, toParams, fromState, fromParams) {
            _this.isLocationChange = _this.isLocationChangeInitial;
            _this.isLocationChangeInitial = true;
        });
    };
    EditSharedReqPageController.prototype.receiveFormalizedComment = function (event) {
        this.requisitionNote = event;
    };
    EditSharedReqPageController.prototype.onVoiceTranscript = function (transcript) {
        if (this.requisitionNote) {
            this.requisitionNote += ' ' + transcript;
        }
        else {
            this.requisitionNote = transcript;
        }
    };
    EditSharedReqPageController.prototype.setFormalizeActivityPayload = function () {
        this.formalizeActivityPayload = {
            candidate: null,
            requisition: new FormalizeRequisition(this.jobId, this.candidateJobMatch.jobMatchRequisitionNum, this.requisitionInfo.requisitionActualNumber),
            jobMatch: null,
            company: new FormalizeCompany(this.companyId, this.$rootScope.userDetails.company.companyName, this.buId, this.requisitionInfo.corporateBU)
        };
    };
    return EditSharedReqPageController;
}());
export { EditSharedReqPageController };
EditSharedReqPageController.$inject = ['$scope', '$state', '$transitions', '$rootScope', '$timeout', 'requisitionService', 'jobService', 'companyService', 'alertsAndNotificationsService', 'MESSAGECONSTANTS', 'uibModalService', 'utilityService'];
// import * as TEMPLATE from './shared-req-restricted-edit-page.html';
import * as TEMPLATE from 'raw-loader!./shared-req-restricted-edit-page.html';
export var EditSharedReqPageComponent = {
    selector: 'editSharedReqPage',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/sharedReqRestrictedEdit/shared-req-restricted-edit-page.html',
        controller: EditSharedReqPageController
    }
};
//# sourceMappingURL=shared-req-restricted-edit-page.component.js.map